// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-bot {
  position: relative;
}
.chat-bot .quickview {
  margin: 80px 0px;
}
.chat-bot .quickview .quickview-header {
  min-height: 40px !important;
}
.chat-bot .quickview .quickview-body {
  overflow-x: hidden;
}
.chat-bot .quickview .quickview-body .quickview-block {
  padding-top: 25px;
}
.chat-bot .quickview .quickview-body .quickview-block .column {
  padding: 0 0.75rem;
}
.chat-bot .chat-bot-btn {
  position: absolute;
  right: 30px;
  bottom: 150px;
  z-index: 10015;
}

/* CSS talk bubble */
.talk-bubble {
  margin: 4px 32px;
  display: inline-block;
  position: relative;
  width: auto;
  height: auto;
  color: #31708f;
  background-color: #d9edf7;
  border-color: #bce8f1;
}

.border {
  border: 8px solid #666;
}

/* Right triangle placed top left flush. */
.tri-right.border.left-top:before {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: -40px;
  right: auto;
  top: -8px;
  bottom: auto;
  border: 32px solid;
  border-color: #666 transparent transparent transparent;
}

.tri-right.left-top:after {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: -20px;
  right: auto;
  top: 0px;
  bottom: auto;
  border: 22px solid;
  border-color: #d9edf7 transparent transparent transparent;
}

/* Right triangle, right side slightly down*/
.tri-right.border.right-in:before {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: auto;
  right: -40px;
  top: 30px;
  bottom: auto;
  border: 20px solid;
  border-color: #666 transparent transparent #666;
}

.tri-right.right-in:after {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: auto;
  right: -20px;
  top: 0px;
  bottom: auto;
  border: 12px solid;
  border-color: #d9edf7 transparent transparent #d9edf7;
}

.right-chat {
  right: 0;
  position: absolute;
  display: block;
}

.left-chat {
  left: 0;
  position: absolute;
  display: block;
}

/* talk bubble contents */
.talktext {
  padding: 1em;
  text-align: left;
  line-height: 1.5em;
}

.talktext p {
  /* remove webkit p margins */
  -webkit-margin-before: 0em;
  -webkit-margin-after: 0em;
}`, "",{"version":3,"sources":["webpack://./src/app/ibm-bot/bot.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AAAE;EACE,gBAAA;AAEJ;AADI;EACE,2BAAA;AAGN;AADI;EACE,kBAAA;AAGN;AAFM;EACE,iBAAA;AAIR;AAHQ;EACE,kBAAA;AAKV;AACE;EACE,kBAAA;EAEA,WAAA;EACA,aAAA;EACA,cAAA;AAAJ;;AAOE,oBAAA;AAEA;EACE,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;AALJ;;AAQE;EACE,sBAAA;AALJ;;AASE,0CAAA;AAEA;EACE,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,sDAAA;AAPJ;;AAUE;EACE,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,yDAAA;AAPJ;;AAWE,4CAAA;AAEA;EACE,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,+CAAA;AATJ;;AAYE;EACE,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,qDAAA;AATJ;;AAYE;EACE,QAAA;EACA,kBAAA;EACA,cAAA;AATJ;;AAYE;EACE,OAAA;EACA,kBAAA;EACA,cAAA;AATJ;;AAYE,yBAAA;AAEA;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;AAVJ;;AAaE;EACE,4BAAA;EACA,0BAAA;EACA,yBAAA;AAVJ","sourcesContent":[".chat-bot {\n  position: relative;\n  .quickview {\n    margin: 80px 0px;\n    .quickview-header {\n      min-height: 40px !important;\n    }\n    .quickview-body {\n      overflow-x: hidden;\n      .quickview-block {\n        padding-top: 25px;\n        .column {\n          padding: 0 0.75rem;\n        }\n      }\n    }\n  }\n\n  .chat-bot-btn {\n    position: absolute;\n    // right: 10px;\n    right: 30px;\n    bottom: 150px;\n    z-index: 10015;\n  }\n}\n\n\n\n\n  /* CSS talk bubble */\n\n  .talk-bubble {\n    margin: 4px 32px;\n    display: inline-block;\n    position: relative;\n    width: auto;\n    height: auto;\n    color: #31708f;\n    background-color: #d9edf7;\n    border-color: #bce8f1;\n  }\n\n  .border {\n    border: 8px solid #666;\n  }\n\n\n  /* Right triangle placed top left flush. */\n\n  .tri-right.border.left-top:before {\n    content: ' ';\n    position: absolute;\n    width: 0;\n    height: 0;\n    left: -40px;\n    right: auto;\n    top: -8px;\n    bottom: auto;\n    border: 32px solid;\n    border-color: #666 transparent transparent transparent;\n  }\n\n  .tri-right.left-top:after {\n    content: ' ';\n    position: absolute;\n    width: 0;\n    height: 0;\n    left: -20px;\n    right: auto;\n    top: 0px;\n    bottom: auto;\n    border: 22px solid;\n    border-color: #d9edf7 transparent transparent transparent;\n  }\n\n\n  /* Right triangle, right side slightly down*/\n\n  .tri-right.border.right-in:before {\n    content: ' ';\n    position: absolute;\n    width: 0;\n    height: 0;\n    left: auto;\n    right: -40px;\n    top: 30px;\n    bottom: auto;\n    border: 20px solid;\n    border-color: #666 transparent transparent #666;\n  }\n\n  .tri-right.right-in:after {\n    content: ' ';\n    position: absolute;\n    width: 0;\n    height: 0;\n    left: auto;\n    right: -20px;\n    top: 0px;\n    bottom: auto;\n    border: 12px solid;\n    border-color: #d9edf7 transparent transparent #d9edf7;\n  }\n\n  .right-chat {\n    right: 0;\n    position: absolute;\n    display: block;\n  }\n\n  .left-chat {\n    left: 0;\n    position: absolute;\n    display: block;\n  }\n\n  /* talk bubble contents */\n\n  .talktext {\n    padding: 1em;\n    text-align: left;\n    line-height: 1.5em;\n  }\n\n  .talktext p {\n    /* remove webkit p margins */\n    -webkit-margin-before: 0em;\n    -webkit-margin-after: 0em;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
